import React from 'react'

interface ArrowProps {
    color?: string
    className?: string
}

const UpArrowBlack: React.FC<ArrowProps> = ({ className }) => (
    <svg
        width="9"
        height="6"
        viewBox="0 0 9 6"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <g id="chevron">
            <path
                id="Vector (Stroke)"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.85355 5.79642C8.65829 5.99169 8.34171 5.99169 8.14645 5.79642L4.5 2.14998L0.853553 5.79642C0.658291 5.99169 0.341708 5.99169 0.146446 5.79642C-0.0488157 5.60116 -0.0488157 5.28458 0.146446 5.08932L4.5 0.735764L8.85355 5.08932C9.04882 5.28458 9.04882 5.60116 8.85355 5.79642Z"
                fill="currentColor"
            />
        </g>
    </svg>
)

export default UpArrowBlack
